import {get, patch, post, put} from "../utils/http.ts";
import {User, UserPreferences} from "../context/UserContext.tsx";
import {BASE_URL} from "./index.ts";

export function getUser(): Promise<User> {
  return get<User>(new URL(`${BASE_URL}/user`));
}

export function getUserPreferences(): Promise<UserPreferences> {
  return get<UserPreferences>(new URL(`${BASE_URL}/user/preferences`));
}

export function updateUserPreferences(preferences: UserPreferences): Promise<UserPreferences> {
  return patch<UserPreferences>(new URL(`${BASE_URL}/user/preferences`), { body: preferences, headers: { 'Content-Type': 'application/json' } });
}

export function updateProfile(firstName: string, lastName: string): Promise<User> {
  return patch<User>(new URL(`${BASE_URL}/user/profile`), {
    body: { first_name: firstName, last_name: lastName },
    headers: { 'Content-Type': 'application/json' }
  });
}

export function changePassword(currentPassword: string, newPassword: string): Promise<User> {
  return put<User>(new URL(`${BASE_URL}/user/password`), {
    body: { current_password: currentPassword, password: newPassword },
    headers: { 'Content-Type': 'application/json' }
  });
}

export function changeEmail(currentPassword: string, newEmail: string): Promise<User> {
  return put<User>(new URL(`${BASE_URL}/user/email`), {
    body: { current_password: currentPassword, email: newEmail },
    headers: { 'Content-Type': 'application/json' }
  });
}

export function resetUserPreferencesToOrganizationDefaults(): Promise<UserPreferences> {
  return post<UserPreferences>(new URL(`${BASE_URL}/user/preferences/reset_to_organization_defaults`), { body: {} });
}
